import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import { AuthContext } from '../../../../contexts/AuthContext';
import { PermissionModulesEnum, PermissionActionsEnum, Modules } from "../../../../enums";
import { hasResourseAccess } from '../../../../utils/methods';

interface HeaderProps {
  view: boolean;
  loading: boolean;
  onComplete: (e: any) => void;
}

const Header: React.FC<HeaderProps> = ({ view, loading, onComplete }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.View] }] })
  const hasCompleteAccess = hasResourseAccess(isSystemAdmin, permissions, { accessibleTo: [{ [PermissionModulesEnum.Invoices]: [PermissionActionsEnum.Complete] }] })

  const handleGoToListClick = () => {
    navigate(Modules.invoices);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t("invoices.editPreviewPayment.pageTexts.header.title")}</h4>
        <p>{t("invoices.editPreviewPayment.pageTexts.header.subTitle")}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end gap-3">
        {
          !view && !loading && hasCompleteAccess && <Button
            className="btn btn-success waves-effect waves-light"
            text={t("invoices.editPreviewPayment.pageTexts.header.markCompleted")}
            onClick={onComplete}
          />
        }
        {
          hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light"
              onClick={handleGoToListClick}
              text={t("invoices.editPreviewPayment.pageTexts.header.goToList")}
            />
          )
        }
      </div>
    </div>
  );
}

export default Header;